exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".exploreItem{max-width:calc(17.85714vw + 342.85714px)}", ""]);
